export const isError = (error: unknown): error is Error =>
	error !== null && typeof error === "object" && "message" in error;

export const errorMessage = (error: unknown): string =>
	isError(error) ? error.message : String(error);
